import PropTypes from 'prop-types'
import React from 'react'

export default function IconCalendar({ styles }) {
  return (
    <svg
      style={styles}
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59018 9.59357H0V1.30469H8.28889V5.52431H7.56216V2.02948H0.724796V8.86878H5.59018V9.59357Z"
        fill="#898989"
      />
      <path
        d="M7.89406 3.53125H0.395508V4.25605H7.89406V3.53125Z"
        fill="#898989"
      />
      <path
        d="M2.63105 0.46875H1.90625V2.91493H2.63105V0.46875Z"
        fill="#898989"
      />
      <path
        d="M6.38202 0.46875H5.65723V2.91493H6.38202V0.46875Z"
        fill="#898989"
      />
      <path
        d="M7.21947 10.5913C8.82171 10.5913 10.1206 9.29241 10.1206 7.69017C10.1206 6.08793 8.82171 4.78906 7.21947 4.78906C5.61723 4.78906 4.31836 6.08793 4.31836 7.69017C4.31836 9.29241 5.61723 10.5913 7.21947 10.5913Z"
        fill="#898989"
      />
      <path
        d="M8.70732 9.30572C8.82491 9.18813 8.82491 8.9973 8.70732 8.87778L7.48519 7.65565L7.49097 6.43545C7.49097 6.35449 7.46013 6.27931 7.40423 6.22148C7.34833 6.16365 7.27122 6.13281 7.19026 6.13281C7.1093 6.13281 7.03219 6.16365 6.97629 6.22148C6.92039 6.27739 6.88762 6.35256 6.88762 6.43353L6.88184 7.7771V7.78288C6.88184 7.79252 6.88184 7.80023 6.88376 7.80987C6.88376 7.81372 6.88376 7.81758 6.88569 7.82143V7.82529C6.88569 7.83107 6.88762 7.83493 6.88762 7.83878C6.88762 7.84264 6.88955 7.84842 6.89147 7.85227L6.8934 7.85613C6.8934 7.85999 6.89533 7.86384 6.89726 7.8677C6.89918 7.87155 6.89918 7.87541 6.90111 7.87926L6.90304 7.88312C6.90497 7.88697 6.90497 7.89083 6.9069 7.89468C6.90882 7.89854 6.91075 7.90239 6.91268 7.90625L6.91461 7.9101C6.91653 7.91396 6.91846 7.91781 6.92039 7.92167C6.92232 7.92553 6.92424 7.92938 6.92617 7.93131L6.9281 7.93516C6.93003 7.93902 6.93196 7.94287 6.93388 7.94673C6.93774 7.95058 6.93967 7.95637 6.94352 7.96022L7.01099 7.91203L6.94545 7.96215C6.94738 7.96408 6.9493 7.96793 6.95123 7.96986C6.95701 7.97757 6.9628 7.98335 6.96858 7.99107L8.28131 9.30379C8.39697 9.42331 8.58973 9.42331 8.70732 9.30572Z"
        fill="white"
      />
    </svg>
  )
}

IconCalendar.propTypes = {
  styles: PropTypes.any,
}
